import { Flex } from '@withjoy/joykit';
import React from 'react';
import { styles, StyledMenuButton } from './MenuButton.styles';
import { isInIframe } from '@shared/utils/isInIframe';
import { Hamburger } from '@withjoy/joykit/icons';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { label4ToNavigationOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { pxToRem } from '@withjoy/joykit/theme';
import { useColorPaletteProvider } from '@apps/guest/packages/layout-engine/layouts/ColorPaletteProvider/ColorPaletteProvider';

const isPreviewing = isInIframe();

interface Props
  extends Readonly<{
    onClick: () => void;
    isCustomPage?: boolean;
    topOffset?: number;
  }> {}

export const MenuButton: React.FC<Props> = ({ onClick, isCustomPage, topOffset = 0 }) => {
  const { pageColor, pageFontColor } = useColorPaletteProvider();

  return (
    <StyledMenuButton
      {...styles.button(isCustomPage, topOffset)}
      onClick={onClick}
      isPreviewing={isPreviewing}
      aria-label="Menu"
    >
      <GuestSiteTypographyOverride override={label4ToNavigationOverride}>
        <Flex
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
          backgroundColor={pageColor}
          borderRadius={pxToRem(12)}
          overflow="hidden"
          color={pageFontColor}
        >
          <Hamburger size={32} />
        </Flex>
      </GuestSiteTypographyOverride>
    </StyledMenuButton>
  );
};

export default MenuButton;
